module.exports = {
    apiKey: "AIzaSyAHOPTUQ2X8XspgcYsPtdc5dwFeV6DW6dI",
    authDomain: "ostfriesland-programmiert.firebaseapp.com",
    databaseURL: "https://ostfriesland-programmiert.firebaseio.com",
    projectId: "ostfriesland-programmiert",
    storageBucket: "ostfriesland-programmiert.appspot.com",
    messagingSenderId: "510619792492",
    appId: "1:510619792492:web:7a7504561fc131c08dd449",
    measurementId: "G-W4ES64W06E"
};
